import { useArticlesFilters } from 'collection/pages/articles/hooks/useArticlesFilters';
import { routeGenerator } from 'lib-knowledge-utils/routes';
import { StringParam, useQueryParams } from 'use-query-params';

import { useCollectionId } from './useCollectionId';

type UseArticleEditorBackLinkReturn = {
  to: string;
  text: string;
};

function useArticleEditorBackLink(): UseArticleEditorBackLinkReturn {
  const collectionId = useCollectionId();
  const { store: articlesFiltersStore } = useArticlesFilters();
  const [params] = useQueryParams({
    articleParams: StringParam,
  });

  const articleParams =
    typeof params.articleParams === 'string'
      ? decodeURIComponent(params.articleParams)
      : undefined;

  return typeof articleParams === 'string' || !collectionId
    ? {
        to: routeGenerator.articles(articleParams),
        text: 'Back to articles',
      }
    : {
        to: routeGenerator.collectionEdit({
          collectionId,
          articlesFiltersStore,
        }),
        text: 'Back to collection',
      };
}

export default useArticleEditorBackLink;
